'use client';

import React from 'react';

const StandardsRelationshipSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-12 leading-tight">
            Relationship to AI Governance Standards
          </h2>

          <div className="space-y-8 text-lg text-gray-800 font-body leading-relaxed">
            <p>
              AI Change Leadership operates in a complementary relationship with formal AI governance and management system standards, including ISO/IEC 42001.
            </p>

            <div className="bg-white border-2 border-gray-200 p-10">
              <h3 className="text-2xl font-bold text-[#0A2540] mb-6">ISO/IEC 42001: AI Management Systems</h3>
              <p className="mb-6">
                ISO/IEC 42001 defines requirements for AI governance and control—establishing what organisations must implement to manage AI systems responsibly. It provides a structured framework for risk management, compliance, and operational oversight.
              </p>
              <p className="mb-6">
                AI Change Leadership focuses on the human, leadership, and organisational change dimensions that sit outside formal management system standards. These are the capabilities required to implement governance frameworks effectively in practice:
              </p>
              <ul className="space-y-4 ml-6">
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-2 h-2 bg-[#0A2540] rounded-full mt-2"></span>
                  <span><strong>Leadership alignment and accountability</strong> for continuous AI-driven transformation</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-2 h-2 bg-[#0A2540] rounded-full mt-2"></span>
                  <span><strong>Operating model adaptation</strong> to enable responsible scaling and evolution</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-2 h-2 bg-[#0A2540] rounded-full mt-2"></span>
                  <span><strong>Workforce enablement</strong> beyond technical skills to cultural readiness and role design</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-2 h-2 bg-[#0A2540] rounded-full mt-2"></span>
                  <span><strong>Adoption intelligence</strong> to guide leadership decisions with clarity</span>
                </li>
              </ul>
            </div>

            <div className="bg-[#0A2540] text-white p-10">
              <p className="text-xl md:text-2xl font-bold leading-relaxed mb-4">
                AI Change Leadership is an enabler of effective ISO/IEC 42001 implementation.
              </p>
              <p className="text-lg leading-relaxed">
                Organisations that develop mature AI Change Leadership capabilities are better positioned to implement governance standards successfully—translating requirements into operational reality, embedding accountability, and sustaining transformation momentum as AI evolves.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#0A2540] mb-4">Complementary, Not Equivalent</h3>
              <p>
                AI Change Leaders does not certify, audit, or replace ISO/IEC 42001. We assess and recognise organisational maturity in the leadership and adoption capabilities that enable standards like ISO/IEC 42001 to be implemented effectively. This is a distinct but complementary focus—addressing the gap between governance requirements and real-world organisational readiness.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StandardsRelationshipSection;